import { render, staticRenderFns } from "./uploadFile.vue?vue&type=template&id=e3648010&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3648010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3648010')) {
      api.createRecord('e3648010', component.options)
    } else {
      api.reload('e3648010', component.options)
    }
    module.hot.accept("./uploadFile.vue?vue&type=template&id=e3648010&scoped=true", function () {
      api.rerender('e3648010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcDrugList/dialog/uploadFile.vue"
export default component.exports